import { Alert, AlertTitle } from "@mui/material";
import localisations from "../../localisation";

function FilePreCheckValidPane() {
    const { title, description } = localisations.filePreCheckValidPane;

    return (
        <Alert severity="success">
            <AlertTitle>{title}</AlertTitle>
            {description}
        </Alert>
    );
}

export default FilePreCheckValidPane;
